export default function PdfLoader(link) {
  if (link) {
    const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '' : process.env.PUBLIC_URL;
    const url = `${BASE_URL}/pdf/${link}`;
    return () => window.open(url, '_blank');
  }
  return null;
}
